import { render, staticRenderFns } from "./ranking-type-select.vue?vue&type=template&id=5117d1e8&scoped=true&"
import script from "./ranking-type-select.vue?vue&type=script&lang=js&"
export * from "./ranking-type-select.vue?vue&type=script&lang=js&"
import style0 from "./ranking-type-select.vue?vue&type=style&index=0&id=5117d1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117d1e8",
  null
  
)

export default component.exports